export const CAPABILITIES = {
    REPORTS: 'reports',
    POST_FLIGHT: 'postFlight',
    SKILLS: 'skills', // advanced personnel profiling
    UNL_PIC: 'unlPic',
    SHOT_LISTS: 'shotLists',
    CREW_MEMBERS: 'crewMembers',
    ASSETS: 'assets',
    FLIGHT_LOGS: 'flightLogs',
    CUSTOM_CHECKLISTS: 'customCheckLists',
    MISSION_REQUEST: 'missionRequest',
    DRONE_INSPECTIONS: 'droneInspections',
    MAINTENANCE: 'maintenance',
    INCIDENTS: 'incidents',
    OPS_CALENDAR: 'opsCalendar',
    CUSTOMERS: 'customers',
    TEAM_MANAGEMENT: 'teamManagement',
    ANALYTICS: 'analytics',
    ADVANCED_SUPPORT: 'advancedSupport',
};

const PLAN_CAPABILITIES = {
    free: [],
    pro: [
        CAPABILITIES.REPORTS,
        CAPABILITIES.POST_FLIGHT,
    ],
    business: [
        CAPABILITIES.REPORTS,
        CAPABILITIES.POST_FLIGHT,
        CAPABILITIES.SKILLS,
        CAPABILITIES.ASSETS,
        CAPABILITIES.CUSTOMERS,
        CAPABILITIES.SHOT_LISTS,
        CAPABILITIES.MISSION_REQUEST,
    ],
    enterprise: [
        CAPABILITIES.REPORTS,
        CAPABILITIES.POST_FLIGHT,
        CAPABILITIES.SKILLS,
        CAPABILITIES.ASSETS,
        CAPABILITIES.CUSTOMERS,
        CAPABILITIES.SHOT_LISTS,
        CAPABILITIES.MAINTENANCE,
        CAPABILITIES.INCIDENTS,
        CAPABILITIES.MISSION_REQUEST,
        CAPABILITIES.CUSTOM_CHECKLISTS,
    ],
};

/**
 * Check if a plan has access to a specific capability.
 * @param {string} planId - The ID of the plan (e.g., 'free', 'pro').
 * @param {string} capability - The capability to check (e.g., 'skills').
 * @returns {boolean} - Whether the plan has the capability.
 */
export const hasCapability = (planId, capability) => {
    if (!planId || !capability) return false;
    const normalizedPlanId = planId.toLowerCase(); // Normalize planId for consistency
    const capabilities = PLAN_CAPABILITIES[normalizedPlanId] || [];
    return capabilities.includes(capability);
};